import { useEffect } from 'react';
import { useMarco, RUTA_INICIO } from './MarcoContext';
import { precargar } from '../../pantallas';

/* Con el panel ya en pantalla y el navegador desocupado, baja en segundo plano las pantallas del menú del usuario
   (primero favoritos y recientes), una a la vez. Así, al abrirlas, ya están listas y no se ve «Cargando pantalla…».
   No hace nada si el equipo pidió ahorrar datos. */
export default function Precarga() {
  const { opciones, opcionesFavoritas, opcionesRecientes } = useMarco();

  useEffect(() => {
    const conexion = navigator.connection || {};
    if (conexion.saveData || /2g/.test(conexion.effectiveType || '')) return undefined;
    const rutas = [RUTA_INICIO, ...opcionesFavoritas.map((o) => o.ruta), ...opcionesRecientes.map((o) => o.ruta), ...opciones.map((o) => o.ruta)];
    const pendientes = [...new Set(rutas.map((r) => r.toLowerCase()))];
    let cancelado = false;
    let espera = null;
    const ocioso = window.requestIdleCallback || ((fn) => setTimeout(() => fn({ timeRemaining: () => 10 }), 300));
    const siguiente = () => {
      if (cancelado || !pendientes.length) return;
      espera = ocioso(() => {
        if (cancelado) return;
        precargar(pendientes.shift()).then(() => { if (!cancelado) siguiente(); });
      }, { timeout: 4000 });
    };
    const inicio = setTimeout(siguiente, 1500);   // deja terminar primero la pantalla actual
    return () => {
      cancelado = true;
      clearTimeout(inicio);
      if (espera && window.cancelIdleCallback) window.cancelIdleCallback(espera);
    };
  }, [opciones, opcionesFavoritas, opcionesRecientes]);

  return null;
}
